import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { CalendarClock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ReminderSettingsCard = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/finance/reminder-settings`).then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  if (!settings) return null;

  const toggle = async (value) => {
    try {
      await axios.put(`${API}/finance/reminder-settings`, { auto_invoice_reminders: value });
      setSettings({ ...settings, auto_invoice_reminders: value });
      toast.success(value ? 'Relances automatiques activées' : 'Relances automatiques désactivées');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Modification impossible');
    }
  };

  return (
    <Card data-testid="reminder-settings-card">
      <CardContent className="pt-6 flex items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <CalendarClock className="w-5 h-5 text-orange-600 mt-0.5" />
          <div>
            <p className="font-medium">Relances automatiques des factures en retard</p>
            <p className="text-sm text-gray-600">
              {settings.schedule} · {settings.emails_enabled ? 'in-app + email' : 'in-app uniquement (emails désactivés dans Paramètres)'} · une facture déjà relancée depuis moins de 6 jours est ignorée
              {settings.last_auto_run && ` · dernier envoi le ${new Date(settings.last_auto_run).toLocaleDateString('fr-FR')}`}
            </p>
          </div>
        </div>
        <Switch checked={settings.auto_invoice_reminders} onCheckedChange={toggle} data-testid="auto-reminders-switch" />
      </CardContent>
    </Card>
  );
};

export default ReminderSettingsCard;
